/**
 * Projects Listing Block - Filter, Search, and Load More Functionality
 * FIXED VERSION - Supports both type and search URL parameters
 */

(function($) {
  'use strict';

  // Initialize on document ready
  $(document).ready(function() {
    initProjectsListing();
  });

  /**
   * Initialize Projects Listing functionality
   */
  function initProjectsListing() {
    // Check for URL parameters on page load
    checkUrlParameter();

    // Handle project card label clicks (prevent page reload if on same page)
    $(document).on('click', '.project-card__label', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const $label = $(this);
      const filterValue = $label.data('filter');
      const labelUrl = $label.attr('href');
      
      // Check if we're already on the same page (compare base URLs)
      const currentBaseUrl = window.location.origin + window.location.pathname;
      const labelBaseUrl = labelUrl.split('?')[0];
      
      if (currentBaseUrl === labelBaseUrl) {
        // Same page - just trigger filter without reload
        const $filterBtn = $('.projects-filter-btn[data-filter="' + filterValue + '"]');
        
        if ($filterBtn.length && !$filterBtn.hasClass('projects-filter-btn--active')) {
          // Update URL parameter
          updateUrlParameter('type', filterValue);
          
          // Trigger filter click programmatically
          $filterBtn.click();
        }
      } else {
        // Different page - navigate normally
        window.location.href = labelUrl;
      }
    });

    // Category filter button click
    $(document).on('click', '.projects-filter-btn', function() {
      const $button = $(this);
      const blockId = $button.data('block-id');
      const filterValue = $button.data('filter');
      
      // Update active state
      const $block = $('#' + blockId);
      $block.find('.projects-filter-btn').removeClass('projects-filter-btn--active');
      $button.addClass('projects-filter-btn--active');
      
      // Check if "All" filter (empty string)
      if (filterValue === '') {
        // Clear search input and URL parameters
        $block.find('.projects-search-input').val('');
        updateUrlParameter('type', '');
        updateUrlParameter('search', '');
        resetAndLoadProjects(blockId, '', '');
      } else {
        // Update type parameter
        updateUrlParameter('type', filterValue);
        // Preserve existing search value
        const searchValue = $block.find('.projects-search-input').val() || '';
        resetAndLoadProjects(blockId, filterValue, searchValue);
      }
    });

    // Search input
    $(document).on('keyup', '.projects-search-input', function() {
      const blockId = $(this).data('block-id');
      const searchValue = $(this).val();
      const $block = $('#' + blockId);
      const $activeFilter = $block.find('.projects-filter-btn--active');
      const filterValue = $activeFilter.length ? $activeFilter.data('filter') : '';

      // Debounce search
      clearTimeout(window.projectsSearchTimeout);
      window.projectsSearchTimeout = setTimeout(function() {
        // Update URL with search parameter
        updateUrlParameter('search', searchValue);
        resetAndLoadProjects(blockId, filterValue, searchValue);
      }, 500);
    });

    // Infinite Scroll Sentinel Observer
    const sentinelObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const $sentinel = $(entry.target);
                const blockId = $sentinel.data('block-id');
                const $block = $('#' + blockId);
                const $grid = $block.find('.projects-listing__grid');
                
                // Check if already loading or no more pages
                if ($grid.hasClass('loading')) return;
                
                const currentPage = parseInt($grid.data('page')) || 1;
                const totalPages = parseInt($grid.data('total-pages')) || 1;

                if (currentPage >= totalPages) {
                    return;
                }

                const itemsPerPage = parseInt($grid.data('items-per-page')) || 12;
                const cpt = $grid.data('cpt') || 'project';
                const nextPage = currentPage + 1;
                
                const $activeFilter = $block.find('.projects-filter-btn--active');
                const filterValue = $activeFilter.length ? $activeFilter.data('filter') : '';
                const searchValue = $block.find('.projects-search-input').val() || '';

                loadMoreProjects(blockId, nextPage, filterValue, searchValue, cpt, itemsPerPage);
            }
        });
    }, { rootMargin: '200px' }); // Load when 200px away 

    // Observe sentinels
    setTimeout(() => {
        $('.projects-listing__sentinel').each(function() {
            sentinelObserver.observe(this);
        });
    }, 500); // Small delay to ensure DOM is ready

  }

  /**
   * Reset grid and load first page with filters
   */
  function resetAndLoadProjects(blockId, filterValue, searchValue) {
    const $block = $('#' + blockId);
    const $grid = $block.find('.projects-listing__grid');
    const itemsPerPage = parseInt($grid.data('items-per-page')) || 12;
    const cpt = $grid.data('cpt') || 'project';

    // Reset grid to page 1
    $grid.data('page', 1);
    
    // Reset sentinel visibility
    $block.find('.projects-listing__sentinel').show();

    // Clear existing projects
    const $noResults = $block.find('.projects-listing__no-results');
    if ($noResults.length) {
      $noResults.remove();
    }

    // Show top loader and hide grid
    $block.find('.projects-listing__loader').not('.projects-listing__loader--bottom').show();
    $grid.hide();
    
    // Add loading class
    $grid.addClass('loading');

    // Fetch new projects
    loadMoreProjects(blockId, 1, filterValue, searchValue, cpt, itemsPerPage, true);
  }

  /**
   * Load more projects via AJAX
   */
  function loadMoreProjects(blockId, page, filterValue, searchValue, cpt, itemsPerPage, reset = false) {
    const $block = $('#' + blockId);
    const $grid = $block.find('.projects-listing__grid');
    const $sentinel = $block.find('.projects-listing__sentinel');
    let $loader = $block.find('.projects-listing__loader');

    // Mark grid as loading
    $grid.addClass('loading');

    // Show appropriate loader
    if (!reset) {
      // Load more: show bottom loader
      $loader = $block.find('.projects-listing__loader--bottom');
      $loader.show();
    } else {
      // Filter/search: loader already shown by resetAndLoadProjects
    }

    $.ajax({
      url: projectsListingData.ajax_url,
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'atlas_load_more_projects',
        nonce: projectsListingData.nonce,
        paged: page,
        cpt: cpt,
        items_per_page: itemsPerPage,
        filter_type: filterValue,
        search: searchValue,
      },
      success: function(response) {
        if (response.success) {
          const data = response.data;

          if (reset) {
            // Clear grid for new search/filter
            $grid.html(data.html);
            // Hide top loader and show grid
            $block.find('.projects-listing__loader').not('.projects-listing__loader--bottom').hide();
            $grid.show();
          } else {
            // Append new items
            $grid.append(data.html);
            // Hide bottom loader
            $block.find('.projects-listing__loader--bottom').hide();
          }

          // Update grid data
          $grid.data('page', data.current_page);
          $grid.data('total-pages', data.total_pages);

          // Show/hide sentinel based on pages
          if ($sentinel.length) {
            if (data.current_page >= data.total_pages) {
              $sentinel.hide();
            } else {
              $sentinel.show();
            }
          }
        } else {
          console.error('AJAX Error:', response.data);
          // Hide all loaders on error
          $block.find('.projects-listing__loader').hide();
          $grid.show();
        }
      },
      error: function(xhr, status, error) {
        console.error('Load more error:', error);
      },
      complete: function() {
        // Remove loading class
        $grid.removeClass('loading');
        $block.find('.projects-listing__loader').not('.projects-listing__loader--bottom').hide();
        // Hide bottom loader explicitly if it was shown
        $block.find('.projects-listing__loader--bottom').hide();
        
        $grid.show();
      },
    });
  }

  /**
   * Check for URL parameters (type and search) and apply on page load
   * FIXED: Now properly handles both parameters together
   */
  function checkUrlParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get('type');
    const searchParam = urlParams.get('search');
    
    // Get the projects listing block
    let $targetBlock = $('.block-projects-listing').first();
    let blockId = $targetBlock.attr('id');
    
    if (!blockId) {
      return; // No block found
    }
    
    // Activate type filter if present
    if (typeParam) {
      const $filterBtn = $('.projects-filter-btn[data-filter="' + typeParam + '"]');
      if ($filterBtn.length) {
        blockId = $filterBtn.data('block-id');
        $targetBlock = $('#' + blockId);
        $targetBlock.find('.projects-filter-btn').removeClass('projects-filter-btn--active');
        $filterBtn.addClass('projects-filter-btn--active');
      }
    }
    
    // Set search input value if search parameter present
    if (searchParam) {
      const $searchInput = $targetBlock.find('.projects-search-input');
      if ($searchInput.length) {
        $searchInput.val(searchParam);
      }
    }
    
    // Load projects with BOTH parameters if any exist
    if (typeParam || searchParam) {
      const filterValue = typeParam || '';
      const searchValue = searchParam || '';
      resetAndLoadProjects(blockId, filterValue, searchValue);
    }
  }

  /**
   * Update URL parameter without reloading page
   */
  function updateUrlParameter(key, value) {
    const url = new URL(window.location);
    
    if (value && value !== '') {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
    
    window.history.pushState({}, '', url);
  }
})(jQuery);
